import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Col, Container, Row } from 'react-bootstrap';

const HotelLoader = ({ length }) => (
  <SkeletonTheme baseColor="#202020" highlightColor="#444">
    <Container>
      <Row className="mt-5 px-md-10 px-sm-2">
        {Array.from({ length }).map(() => (
          <Col md={3} key={Math.random()}>
            <Skeleton height={150} className="" />
            <Skeleton />
            <Skeleton />
          </Col>
        ))}
      </Row>
    </Container>
  </SkeletonTheme>
);
export default React.memo(HotelLoader);
